export const defaultAlertInfo = {
  open: false,
  severity: '',
  message: '',
}